/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'nl-be',
  Pagination: {
    items_per_page: '/ pagina',
    jump_to: 'Ga naar',
    jump_to_confirm: 'bevestigen',
    page: '',
    prev_page: 'Vorige pagina',
    next_page: 'Volgende pagina',
    prev_5: "Vorige 5 pagina's",
    next_5: "Volgende 5 pagina's",
    prev_3: "Vorige 3 pagina's",
    next_3: "Volgende 3 pagina's"
  },
  DatePicker: {
    lang: {
      placeholder: 'Selecteer datum',
      rangePlaceholder: ['Begin datum', 'Eind datum'],
      locale: 'nl_BE',
      today: 'Vandaag',
      now: 'Nu',
      backToToday: 'Terug naar vandaag',
      ok: 'Ok',
      clear: 'Reset',
      month: 'Maand',
      year: 'Jaar',
      timeSelect: 'Selecteer tijd',
      dateSelect: 'Selecteer datum',
      monthSelect: 'Kies een maand',
      yearSelect: 'Kies een jaar',
      decadeSelect: 'Kies een decennium',
      yearFormat: 'YYYY',
      dateFormat: 'D-M-YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D-M-YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Vorige maand (PageUp)',
      nextMonth: 'Volgende maand (PageDown)',
      previousYear: 'Vorig jaar (Control + left)',
      nextYear: 'Volgend jaar (Control + right)',
      previousDecade: 'Vorig decennium',
      nextDecade: 'Volgend decennium',
      previousCentury: 'Vorige eeuw',
      nextCentury: 'Volgende eeuw'
    },
    timePickerLocale: {
      placeholder: 'Selecteer tijd'
    }
  },
  TimePicker: {
    placeholder: 'Selecteer tijd'
  },
  Calendar: {
    lang: {
      placeholder: 'Selecteer datum',
      rangePlaceholder: ['Begin datum', 'Eind datum'],
      locale: 'nl_BE',
      today: 'Vandaag',
      now: 'Nu',
      backToToday: 'Terug naar vandaag',
      ok: 'Ok',
      clear: 'Reset',
      month: 'Maand',
      year: 'Jaar',
      timeSelect: 'Selecteer tijd',
      dateSelect: 'Selecteer datum',
      monthSelect: 'Kies een maand',
      yearSelect: 'Kies een jaar',
      decadeSelect: 'Kies een decennium',
      yearFormat: 'YYYY',
      dateFormat: 'D-M-YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D-M-YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Vorige maand (PageUp)',
      nextMonth: 'Volgende maand (PageDown)',
      previousYear: 'Vorig jaar (Control + left)',
      nextYear: 'Volgend jaar (Control + right)',
      previousDecade: 'Vorig decennium',
      nextDecade: 'Volgend decennium',
      previousCentury: 'Vorige eeuw',
      nextCentury: 'Volgende eeuw'
    },
    timePickerLocale: {
      placeholder: 'Selecteer tijd'
    }
  },
  Table: {
    filterTitle: 'FilterMenu',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    selectAll: 'Selecteer huidige pagina',
    selectInvert: 'Selecteer huidige pagina'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Annuleer',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Annuleer'
  },
  Transfer: {
    searchPlaceholder: 'Zoek hier',
    itemUnit: 'item',
    itemsUnit: 'items'
  },
  Upload: {
    uploading: 'Uploaden...',
    removeFile: 'Bestand verwijderen',
    uploadError: 'Upload fout',
    previewFile: 'Preview bestand',
    downloadFile: 'Download bestand'
  },
  Empty: {
    description: 'Geen gegevens'
  }
};
